import { useRef, useState } from 'react';
import type React from 'react';

/** Selected index plus arrow-key navigation for an ARIA tablist. */
export function useRovingTabs(count: number, initial = 0) {
  const [selected, setSelected] = useState(initial);
  const refs = useRef<(HTMLButtonElement | null)[]>([]);

  const onKeyDown = (e: React.KeyboardEvent, index: number) => {
    const forward = e.key === 'ArrowDown' || e.key === 'ArrowRight';
    const back = e.key === 'ArrowUp' || e.key === 'ArrowLeft';
    if (!forward && !back) return;
    e.preventDefault();
    const next = (index + (forward ? 1 : -1) + count) % count;
    setSelected(next);
    refs.current[next]?.focus();
  };

  const tabProps = (index: number) => ({
    ref: (el: HTMLButtonElement | null) => {
      refs.current[index] = el;
    },
    role: 'tab' as const,
    type: 'button' as const,
    'aria-selected': index === selected,
    tabIndex: index === selected ? 0 : -1,
    onClick: () => setSelected(index),
    onKeyDown: (e: React.KeyboardEvent) => onKeyDown(e, index),
  });

  return { selected, setSelected, tabProps };
}
